// Every word the Review tab shows, in one place for the content team to
// review.

export const HOW_IT_WORKS =
  'Stories wait here until an editor publishes them. Check the draft against what the websites said, fix anything wrong, then publish.';

export const LIST = {
  exchange: 'Exchange',
  exchangeTip:
    "The stock exchange you're working on. Everything on this page is for that exchange only.",
  pickExchange: 'Pick an exchange to see its drafts.',
  waiting: n => `${n} ${n === 1 ? 'draft' : 'drafts'} waiting`,
  waitingTip:
    'Stories written and waiting for an editor. Nothing here is live yet.',
  written: time => `written ${time}`,
  from: 'From',
  empty: 'No drafts waiting. New stories appear here as they are written.',
  emptySearch: 'No drafts match your search.',
  emptyWebsite: 'No drafts from this website yet.',
  search: 'Search drafts',
  searchTip: 'Search by headline or by the website the story came from.',
  website: 'Website',
  websiteTip: 'Show only drafts from this website.',
  notReady: x =>
    `Drafts for ${x} will appear here once the tech team switches on reviewing. Until then, written stories are published straight away.`,
  open: 'Review',
};

export const LANGUAGE_LABEL = {EN: 'English', FR: 'French'};

export const DRAFT = {
  back: 'Back to review',
  written: time => `Written ${time}`,
  from: outlets => `From: ${outlets}`,
  bothLanguages: 'Both versions go live together. Check both.',
  heldBecause: names =>
    `Waiting because ${names} ${
      names.includes(' and ') ? 'publish' : 'publishes'
    } only after review.`,
  writtenOnRequest:
    'Written on request: an admin asked for it before a second website reported it.',
  publishedWithEdits: 'Published with your changes.',
  publishedAsWritten: 'Published as written.',
  headline: 'Headline',
  headlineTip:
    'The title on the website and in search results. Keep it short and factual.',
  headlineEmpty: 'The headline is empty.',
  story: 'Story',
  storyTip: 'The main article. Keep every figure as the websites reported it.',
  keyTakeaway: 'Key takeaway',
  keyTakeawayTip:
    'One paragraph on why the story matters, shown under the story.',
  summary: 'Summary',
  summaryTip: 'Three one-line points shown at the top of the article.',
  point: n => `Point ${n}`,
  searchDescription: 'Search description',
  searchDescriptionTip:
    'The short text under the headline in Google results. Under 160 characters.',
  picture: 'Picture',
  pictureTip:
    'Shown at the top of the story and when it is shared. Both versions use the same one.',
  noPicture: 'No picture yet',
  addPicture: 'Add picture',
  changePicture: 'Change picture',
  pictureUploading: 'Wait for the picture to finish uploading.',
  pictureFailed: 'Could not upload this picture. Try again.',
  imageDescription: 'Image description',
  imageDescriptionTip:
    "Describes the picture for people who can't see it, and for search engines.",
  webAddress: 'Web address',
  webAddressTip:
    "The end of the story's link. Changing it after publishing breaks links people have shared.",
  keywords: 'Keywords',
  keywordsTip: 'Search terms for this story. Four to eight is enough.',
  type: 'Type',
  typeTip: 'The news section the story appears in.',
  tag: 'Tag',
  tagTip: 'The topic label used to group similar stories.',
  companies: 'Companies in this story',
  companiesTip:
    "Each company gets a link to its company page. Remove any the story doesn't really cover.",
  sources: 'What the websites said',
  sourcesTip: 'The original articles. Check names and figures against them.',
  publish: 'Publish',
  publishTip: 'Publishes the English and French versions now.',
  publishTitle: 'Publish this story?',
  publishAsIs: 'Both versions go live now, as written.',
  publishEdited: 'Both versions go live now, with your changes.',
  oneLanguageEdited: (edited, other) =>
    `You changed the ${edited} version. The ${other} version was not updated. Edit it too, or publish as it is.`,
  published: title => `Published: ${title}`,
  publishedAlert: 'Published',
  openArticle: 'Open article',
  reject: "Don't publish",
  rejectTip:
    'Drops this draft. The reason helps us learn which websites to trust.',
  rejected: 'Not published',
  rejectedToast: "Draft dropped. It won't be published.",
  reason: 'Reason',
  reasonTip: 'Helps us see which websites send unsuitable stories.',
  reasons: [
    {value: 'NOT_RELEVANT', label: 'Not relevant'},
    {value: 'WRONG_FACTS', label: 'Wrong or unsupported facts'},
    {value: 'DUPLICATE', label: 'Duplicate'},
    {value: 'POORLY_WRITTEN', label: 'Poorly written'},
    {value: 'OTHER', label: 'Other'},
  ],
  other: 'Tell us more',
  otherOptional: 'Anything to add? (optional)',
};

export const STATUS = {
  PENDING_REVIEW: {color: 'orange', label: 'Waiting for review'},
  PUBLISHED: {color: 'green', label: 'Published'},
  REJECTED: {color: 'default', label: 'Not published'},
};

export const TAG_OPTIONS = [
  ['STOCKS', 'Stocks'],
  ['FINANCE', 'Finance'],
  ['BUSINESS', 'Business'],
  ['ECONOMY', 'Economy'],
  ['STARTUP', 'Startups'],
  ['VENTURE_CAPITAL', 'Venture capital'],
].map(([value, label]) => ({value, label}));

export const TYPE_OPTIONS = [
  ['AFRICAN_STOCKS_AND_FINANCE', 'African stocks and finance'],
  ['AFRICAN_BUSINESS_AND_ECONOMY', 'African business and economy'],
  ['BREAKING_NEWS', 'Breaking news'],
  ['STARTUP_VENTURE_CAPITAL', 'Startups and venture capital'],
].map(([value, label]) => ({value, label}));
